var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"label":_vm.label,"dense":"","outlined":"","rules":_vm.rules,"value":_vm.value},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }